<nav id="sampleNav" class="dnb-global-header header-utility-btns navbar navbar-default">
  <div class="d-flex w-100 align-items-center">
    <!-- <div class="navbar-header" style="width: 873px;"> -->
    <!-- <button type="button" class="navbar-toggle collapsed" data-toggle="collapse"
          data-target="#example-navbar-collapse-1">
          <span class="sr-only">Toggle navigation</span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </button> -->
    <!-- <div style="float:left"> -->
    <a aria-label="Link to Data Integration Toolkit" href="https://www.dnb.com"><span class="dnb-logo"></span> </a>
    <span class="integrate-title"><strong><span class="integrate-title">Data Integration
                Toolkit</span></strong></span>
    <!-- </div> -->
    <div id="example-search-collapse-1" class="search-group collapse navbar-collapse">
      <div class="input-group">
        <div class="search-selector input-group-btn">
        </div> <!-- /.input-group-btn -->
      </div>
    </div>
    <!-- </div> -->
    <div class="ml-auto">
      <ul class="top-menu-items mb-0" style="float:right;font-size:10px;padding-right:10px;min-width: auto;white-space: nowrap;">
        <li><a aria-label="DNB.com" href="https://www.dnb.com/" >DNB.com</a></li>
        <li><a aria-label="Contact Us" href="http://www.dnb.com/company/contact-us.html">Contact Us</a></li>
         <li><a aria-label="Business FAQs" [routerLink]="'/unlocked/frequently-asked-questions'">Business FAQs</a></li>
      </ul>
    </div>


    <!-- Collect the nav links, forms, and other content for toggling -->
    <!-- /.navbar-collapse -->

  </div> <!-- /.container-fluid -->
</nav>

<nav>
  <div class="collapse navbar-collapse menubar" id="example-navbar-collapse-3"  style="display: grid;">
    <form [formGroup]="searchForm">
      <div style="float:left;">
        <ul class="nav navbar-nav navbar-left menubar-title">
          <li class="center-menu"><a aria-label="Toolkit Home" [routerLink]="'/data-integration-toolkit-home'">Toolkit Home</a></li>
          <li class="center-menu"><a aria-label="Solutions" [routerLink]="'/unlocked/solutions-home'">Solutions</a></li>
          <li class="center-menu"><a aria-label="Technology" [routerLink]="'/unlocked/technology'">Technology</a></li>
          <li class="center-menu"><a aria-label="Support" [routerLink]="'/unlocked/support'">Support</a></li>
          <!-- <li class="center-menu"><a [routerLink]="'/unlocked/site-search'">Site Search</a></li> -->

        </ul>

      </div>

      <div class="SearchLangContanier">


        <div class="SearchContainer">
          <input aria-label="Search" type="text" class="form-control overallsearch" #Searchtext placeholder="Search" formControlName="search">
          <button aria-label="Go" tabindex=0 class="btn-sm btn-primary searchbutton" type="button" (click)="SearchQuery(Searchtext.value)">Go</button>
          <select id="language" name="language" formControlName="language" class="form-control language" aria-label="language"
          (change)="selectLanguageValue($event);" *ngIf="router.url === '/' || router.url ==='/data-integration-toolkit-home' || router.url ==='/data-integration-toolkit-home-du' || router.url ==='/data-integration-toolkit-home-fr' || router.url ==='/data-integration-toolkit-home-it' || router.url ==='/data-integration-toolkit-home-jp' || router.url ==='/data-integration-toolkit-home-nt' || router.url ==='/data-integration-toolkit-home-po' || router.url ==='/data-integration-toolkit-home-sp' ||
          router.url ==='/unlocked/solutions-home' || router.url ==='/unlocked/solutions-home-du' || router.url ==='/unlocked/solutions-home-fr' || router.url ==='/unlocked/solutions-home-it' || router.url ==='/unlocked/solutions-home-jp' || router.url ==='/unlocked/solutions-home-nt' || router.url ==='/unlocked/solutions-home-po' || router.url ==='/unlocked/solutions-home-sp' ||
          router.url ==='/unlocked/technology' || router.url ==='/unlocked/technology-du' || router.url ==='/unlocked/technology-fr' || router.url ==='/unlocked/technology-it' || router.url ==='/unlocked/technology-jp' || router.url ==='/unlocked/technology-nt' || router.url ==='/unlocked/technology-po' || router.url ==='/unlocked/technology-sp' ||
          router.url ==='/unlocked/support' || router.url ==='/unlocked/support-du' || router.url ==='/unlocked/support-fr' || router.url ==='/unlocked/support-it' || router.url ==='/unlocked/support-jp' || router.url ==='/unlocked/support-po' || router.url ==='/unlocked/support-sp' || router.url ==='/unlocked/support-nt'">              
          <option value="Select" [selected]="true"> ---Select the language--- </option>
          <option value='English' lang="en">English</option>
          <option value="Deutsch" lang="de">Deutsch</option>
          <option value="Francais" lang="fr">Francais</option>
          <option value="Italiano" lang="it">Italiano</option>
          <option value="Japanese" lang="jp">Japanese</option>
          <option value="Portuguese" lang="pt">Portuguese</option>
          <option value="Espanol" lang="es">Espanol</option>
          <option value="Netherlands" lang="nl">Netherlands</option>              
          </select>
        </div>
        <div class="LanguageSelection">
         
        </div>
      </div>

    </form>
  </div>
</nav>
<div class="app-container">

  <div class="container-fluid pr-0 pl-0">
    <div class="col-md-12 col-sm-12">

      <div class="row">
        <div class="col-sm-2 pl-0 sidebar">
          <app-sidebar></app-sidebar>
        </div>
        <div class="col-sm pt-3" style="overflow: auto;">
          <router-outlet></router-outlet>

        </div>
        <div class="clearfix"></div>
      </div>
    </div>
  </div>
</div>
<maui-footer></maui-footer>